import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ShipmentHistorySearch from './pages/shipment-history-search';
import TrackingNumberEntryValidation from './pages/tracking-number-entry-validation';
import ReportingAnalyticsDashboard from './pages/reporting-analytics-dashboard';
import TeamManagementUserAdministration from './pages/team-management-user-administration';

const Routes = () => {
  return (
   
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<TrackingNumberEntryValidation />} />
        <Route path="/shipment-history-search" element={<ShipmentHistorySearch />} />
        <Route path="/tracking-number-entry-validation" element={<TrackingNumberEntryValidation />} />
        <Route path="/reporting-analytics-dashboard" element={<ReportingAnalyticsDashboard />} />
        <Route path="/team-management-user-administration" element={<TeamManagementUserAdministration />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
   
  );
};

export default Routes;
